'use client';

import moment from 'moment';
import { NextAppDirEmotionCacheProvider } from 'tss-react/next/appDir';
import { TssCacheProvider } from 'tss-react';
import { CacheProvider } from '@emotion/react';
import type { EmotionCache } from '@emotion/cache';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import theme from '../theme';

moment.updateLocale('en', { week: { dow: 1 } });

function EmotionAndTssCacheProvider({ value, children }: { value: EmotionCache; children: React.ReactNode }) {
  return (
    <TssCacheProvider value={value}>
      <CacheProvider value={value}>
        {children}
      </CacheProvider>
    </TssCacheProvider>
  );
}

export default function ThemeRegistry({ children }) {
  return (
    <NextAppDirEmotionCacheProvider
      options={{ key: 'mui', prepend: true }}
      CacheProvider={EmotionAndTssCacheProvider as unknown as React.Provider<EmotionCache>}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterMoment}>
          {children}
        </LocalizationProvider>
      </ThemeProvider>
    </NextAppDirEmotionCacheProvider>
  );
}
